module.exports = __webpack_public_path__ + "static/media/smash.0aaeff7a.jpeg";